/* Delivery estimate — a date instead of «1–3 days» (ported from the v3 theme's
   mw-delivery-estimate, where it earned its place). Computed in the shopper's local time from the
   block's settings: the daily dispatch cut-off, transit days min–max, weekend dispatch.
   Weekends and the Danish public holidays carriers don't drive (Easter moves; computed) are
   skipped. The line under the date names a fixed time — «bestil inden kl. 14» — not a ticking
   clock: the same information without the pressure (a v3 decision worth keeping). */

// Day and month names come from the page language (da: «mandag», «maj»; nb: «mandag», «mai»),
// the sentences from window.Munkwell.strings.delivery (layout/theme.liquid).
const LANG = document.documentElement.lang || 'da';
const DAYS = [...Array(7)].map((_, i) => new Date(2024, 0, 7 + i).toLocaleDateString(LANG, { weekday: 'long' }));
const MONTHS = [...Array(12)].map((_, i) => new Date(2024, i, 1).toLocaleDateString(LANG, { month: 'short' }));
const t = (key, vars = {}) =>
  Object.entries(vars).reduce(
    (text, [name, value]) => text.replaceAll(`%%${name.toUpperCase()}%%`, String(value)),
    window.Munkwell?.strings?.delivery?.[key] || ''
  );
const shift = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
const key = (d) => `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;

function easter(y) {
  const a = y % 19, b = Math.floor(y / 100), c = y % 100;
  const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
  const g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  const i = Math.floor(c / 4), k = c % 4;
  const l = (32 + 2 * e + 2 * i - h - k) % 7;
  const m = Math.floor((a + 11 * h + 22 * l) / 451);
  return new Date(y, Math.floor((h + l - 7 * m + 114) / 31) - 1, ((h + l - 7 * m + 114) % 31) + 1);
}

const HOLIDAYS = new Set();
for (const y of [new Date().getFullYear(), new Date().getFullYear() + 1]) {
  const e = easter(y);
  [new Date(y, 0, 1), shift(e, -3), shift(e, -2), shift(e, 1), shift(e, 39), shift(e, 50),
    new Date(y, 11, 24), new Date(y, 11, 25), new Date(y, 11, 26)].forEach((d) => HOLIDAYS.add(key(d)));
}

const closed = (d, weekendOk) => HOLIDAYS.has(key(d)) || (!weekendOk && (d.getDay() === 0 || d.getDay() === 6));
const addDays = (d, n, weekendOk) => { const x = new Date(d); while (n > 0) { x.setDate(x.getDate() + 1); if (!closed(x, weekendOk)) n -= 1; } return x; };
const fmt = (d) => `${DAYS[d.getDay()]} ${d.getDate()}. ${MONTHS[d.getMonth()]}`;
const relative = (d, now) => {
  const diff = Math.round((new Date(d.getFullYear(), d.getMonth(), d.getDate()) - new Date(now.getFullYear(), now.getMonth(), now.getDate())) / 86400000);
  if (diff === 0) return t('today');
  if (diff === 1) return t('tomorrow');
  if (diff === 2) return t('dayAfterTomorrow');
  return fmt(d);
};

function render(el) {
  const now = new Date();
  const cutoff = Number(el.dataset.cutoff) || 14;
  const min = Number(el.dataset.min) || 1;
  const max = Number(el.dataset.max) || min;
  const weekendOk = el.dataset.weekend === 'true';
  let ship = new Date(now);
  if (!(now.getHours() < cutoff && !closed(ship, weekendOk))) ship = addDays(ship, 1, weekendOk);
  const first = addDays(ship, min, false);
  const last = addDays(ship, max, false);
  const title = el.querySelector('[data-deliv-title]');
  const sub = el.querySelector('[data-deliv-sub]');
  if (!title || !sub) return;
  // One kind of date at both ends of a range: «22.–24. sep.», never «i overmorgen – 24. sep.».
  let when = `${first.getDate()}. ${MONTHS[first.getMonth()]} – ${last.getDate()}. ${MONTHS[last.getMonth()]}`;
  if (min === max) when = relative(first, now);
  else if (first.getMonth() === last.getMonth()) when = `${first.getDate()}.–${last.getDate()}. ${MONTHS[last.getMonth()]}`;
  title.textContent = t('delivery', { when });
  const today = ship.toDateString() === now.toDateString();
  sub.textContent = today
    ? t('dispatchToday', { hour: String(cutoff).padStart(2, '0') })
    : t('dispatchOn', { when: relative(ship, now) });
  el.classList.toggle('is-today', today);
}

const tick = () => document.querySelectorAll('[data-deliv]').forEach(render);
tick();
setInterval(tick, 60000);
document.addEventListener('shopify:section:load', tick);
document.addEventListener('mw:variant:change', tick);
